import {
  SET_USED_WAREHOUSES
} from '../constant/mutation-types'
import service from '@/services/warehouses'
const namespaced = true
const state = {
  isLoaded: false,
  warehousesList: [],
  addingPopup: false
}

const getters = {
  getWarehousesList: state => state.warehousesList,
  getActiveWarehouse(state) {
    const result = state.warehousesList.find(item => item.active)
    if (result) return result
    return null
  },
  getWarehousesLoadingStatus: state => state.isLoaded,
  getWarehousesAddingPopupState: state => state.addingPopup
}

const actions = {
  async loadWarehousesList({ commit, state }) {
    const result = await service.getWarehousesList()
    if (result?.data?.error?.type === 200) {
      commit('setWarehousesList', result.data.data)
      if (state.isLoaded) {
        commit(`user/${SET_USED_WAREHOUSES}`, result.data.data.length, { root: true })
      }
      if (!state.isLoaded) {
        commit('setWarehousesLoaded')
      }
    }
  },
  async setWarehouseActive({ state, commit }, payload) {
    await service.updateWarehouse(state.warehousesList.find(item => item.id === payload))
  }
}

const mutations = {
  handleActiveWarehouse(state, payload) {
    state.warehousesList.forEach(item => {
      if (item.id !== payload) item.active = false
    })
  },
  setWarehouseActive(state, payload) {
    state.warehousesList.forEach(item => {
      if (item.id === payload) {
        item.active = true
      } else {
        item.active = false
      }
    })
  },
  setWarehouseInactive(state, payload) {
    state.warehousesList.find(item => item.id === payload).active = false
  },
  setWarehousesList(state, payload) {
    state.warehousesList = payload
  },
  setWarehousesLoaded: state => { state.isLoaded = true },
  addWarehousePopup: (state, payload) => { state.addingPopup = payload }
}

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations
}
